<template>
  <td class="text-center text-lg">
    {{ moderatorList }}
  </td>
</template>

<script lang="babel">
export default {
  props: {
    model: {
      required: true,
      type: Object,
    }
  },
  computed: {
    moderatorList() {
      return this.model.moderator_profiles.map(profile => {
        return profile.user.name;
      }).join(',');
    }
  }
};
</script>
